import { gql } from '@/__generated__';

const GET_CURRENT_DEVICE_ALERTS = gql(`#graphql
  query GetCurrentDeviceAlerts($deviceId: String!) {
    currentDeviceAlerts(deviceId: $deviceId) {
      levelMin
      levelMax
      overflowLevel
      flowMin
      flowMax
      flowOverflow
      flowType
    }
  }
`);

export default GET_CURRENT_DEVICE_ALERTS;
